import React from 'react';

import AcUnitIcon from '@mui/icons-material/AcUnit';
import { StepIcon, StepIconProps } from '@mui/material';
import { type Components, type Theme } from '@mui/material/styles';

import { DoneCircle } from '../components/DoneCircle';

/**
 * Кастомный компонент иконки шага
 * @param props Пропсы
 */
const StepIconComponent: React.ElementType<
  StepIconProps,
  keyof React.JSX.IntrinsicElements
> = props => {
  if (props.completed) {
    return <DoneCircle />;
  }

  return <StepIcon {...props} />;
};

const MuiStepIcon: Components<Theme>['MuiStepIcon'] = {
  defaultProps: {
    icon: <AcUnitIcon />
  },
  styleOverrides: {
    /**
     * Корневые стили
     * @param root0 Пропсы
     * @param root0.theme Тема
     */
    root: ({ theme }) => ({
      color: 'rgba(255, 169, 97, 0.3)',
      '&.Mui-completed': {
        color: theme.palette.secondary.main
      },
      '&.Mui-active': {
        color: theme.palette.secondary.main
      }
    })
  }
};

const MuiStepLabel: Components<Theme>['MuiStepLabel'] = {
  defaultProps: {
    StepIconComponent
  },
  styleOverrides: {
    /**
     * Стили заголовка
     * @param root0 Пропсы
     * @param root0.theme Тема
     */
    label: ({ theme }) => ({
      color: theme.palette.primary.contrastText,
      '&.Mui-completed': {
        color: theme.palette.primary.contrastText
      },
      '&.Mui-active': {
        color: theme.palette.primary.contrastText
      }
    })
  }
};

export const stepper = { MuiStepIcon, MuiStepLabel };
